import { type PropsWithChildren } from "react";

import {
  SpaceRepositoryProviders,
  type SpaceRepositories,
} from "src/components/SpaceRepositoryProviders";
import { createPrivateAthletesRepository } from "src/repositories/athletes/createPrivateAthletesRepository";
import { createPersonalLibraryExercisesRepository } from "src/repositories/exercises/createPersonalLibraryExercisesRepository";
import { createPersonalLabelsRepository } from "src/repositories/labels/createPersonalLabelsRepository";
import { createPrivateMetricsRepository } from "src/repositories/metrics/createPrivateMetricsRepository";
import { createPersonalLibraryProgramsRepository } from "src/repositories/programs/createPersonalLibraryProgramsRepository";
import { createPrivateQuestionnairesRepository } from "src/repositories/questionnaires/createPrivateQuestionnairesRepository";
import { createPrivateStatisticsRepository } from "src/repositories/statistics/createPrivateStatisticsRepository";
import { createPersonalLibraryWorkoutsRepository } from "src/repositories/workouts/createPersonalLibraryWorkoutsRepository";

const repositories = {
  questionnaires: createPrivateQuestionnairesRepository(),
  statistics: createPrivateStatisticsRepository(),
  metrics: createPrivateMetricsRepository(),
  athletes: createPrivateAthletesRepository(),
  exercises: createPersonalLibraryExercisesRepository(),
  labels: createPersonalLabelsRepository(),
  programs: createPersonalLibraryProgramsRepository(),
  workouts: createPersonalLibraryWorkoutsRepository(),
} satisfies SpaceRepositories;

export function getPrivateSpaceRepositories(): SpaceRepositories {
  return repositories;
}

export function PrivateSpaceRepositoryProviders(props: PropsWithChildren) {
  return (
    <SpaceRepositoryProviders repositories={repositories}>
      {props.children}
    </SpaceRepositoryProviders>
  );
}
